import createVueComponent from '../createVueComponent';
export default createVueComponent('outline', 'currency-manat', 'CurrencyManat', [["path",{"d":"M7 19v-7a5 5 0 1 1 10 0v7","key":"svg-0"}],["path",{"d":"M12 5v14","key":"svg-1"}]]);